import React, { ReactNode } from 'react';

interface ConditionalWrapperProps extends React.PropsWithChildren<{}> {
  wrapper: (node: ReactNode) => JSX.Element;
  condition?: boolean;
}

const ConditionalWrapper = ({ condition, wrapper, children }: ConditionalWrapperProps) => {
  return <>{condition ? wrapper(children) : children}</>;
};

export default ConditionalWrapper;
